// 内网
// const API_URL = `/app-api`

// 线上
const API_URL = `https://wl.zhejiangjinyuan.cn/app-api`

const APIKEYS = {
  // 登录接口
  ApiLogin: `${API_URL}/system/auth/login`,
  // 登录接口
  ApiSmsLogin: `${API_URL}/system/auth/sms-login`,
  // 单点登录获取信息
  ApiGetAuthorize: `${API_URL}/system/oauth2/authorize`,
  // 单点登录获取信息
  ApiPostAuthorize: `${API_URL}/system/oauth2/authorize`,
  // 获得短信验证码
  ApiLoginCode: `${API_URL}/system/auth/send-sms-login-code`,
  // 退出
  ApiLogout: `${API_URL}/system/auth/logout`,
  // 获得告警日历分页
  ApiLogList: `${API_URL}/perception/lot-alarm-log/page`,
  // 获得各分类设备分页
  ApiRealTimePage: `${API_URL}/perception/lot-equipment/getRealTimePage`,
  // 获得温湿度监测报表
  ApiLotTempStatisticsList: `${API_URL}/perception/lot-temp/statisticsList`,
  // 获得空气质量监测报表
  ApiLotAirStatisticsList: `${API_URL}/perception/lot-air/statisticsList`,
  // 获得消防水位监测报表
  ApiLotFireWaterStatisticsList: `${API_URL}/perception/lot-fire-water/statisticsList`,
  // 获得精密空调数据报表
  ApiLotAirConditionerStatisticsList: `${API_URL}/perception/lot-air-conditioner/statisticsList`,
  // 获得用电量监测报表
  ApiLotConsumpStatisticsList: `${API_URL}/perception/lot-consump/statisticsPage`,
  // 获得生活水压监测报表
  ApiLotWaterStatisticsList: `${API_URL}/perception/lot-water/statisticsList`,
  // 查询所有设备位置数据
  ApiLotLocationList: `${API_URL}/perception/lot-location/getLotLocationList`,
  // 查询甲醛监测报表
  ApiLotFormaldehydeStatisticsList: `${API_URL}/perception/lot-formaldehyde/statisticsList`,

  // 获取验证图片以及 token
  ApiGetVerify: `${API_URL}/system/captcha/get`,
  // 滑动或者点选验证
  ApiVerifyCheck: `${API_URL}/system/captcha/check`,
  // 重新获取token
  ApiRefreshToken : `/app-api/system/auth/refresh-token`
  
}

export default APIKEYS
